import { ReportManager } from "@/views/reports/ReportManager";

export class ICPlusPlusReport extends ReportManager {
  public getTransactionHeaders(): Array<string> {
    // Backward compatibility: reports generated before the "Settlement Currency" and
    // "Gross in Settlement Currency" columns were added are stored on AWS with the older (18 column)
    // layout. Pick the header set that matches the stored data so old reports keep downloading
    // without column misalignment.
    if (this.transactionDetails[0]?.length === 18) {
      return ["ID", "Created Date", "Payment Method", "Gross Currency", "Gross", "Chargebee Fee", "Forex Fee",
        "Cross Border Fee", "3DS Fee", "Scheme Fee", "Interchange fee", "Reserve Deduction", "Total Deductions",
        "Net", "Category", "Payout ID", "Dunning", "Parent Transaction"];
    }
    // Intermediate layout (20 columns): "Settlement Currency" + "Gross in Settlement Currency" were added,
    // but "Payout Date" had not been introduced yet. Without this branch these reports fall through to the
    // newest (21 column) header and every column after "Payout ID" shifts by one.
    if (this.transactionDetails[0]?.length === 20) {
      return ["ID", "Created Date", "Payment Method", "Gross Currency", "Gross", "Settlement Currency", "Gross in Settlement Currency", "Chargebee Fee", "Forex Fee", "Cross Border Fee", "3DS Fee", "Scheme Fee",
        "Interchange fee", "Reserve Deduction", "Total Deductions", "Net in Settlement Currency", "Category", "Payout ID", "Dunning", "Parent Transaction"];
    }
    return ["ID", "Created Date", "Payment Method", "Gross Currency", "Gross", "Settlement Currency", "Gross in Settlement Currency", "Chargebee Fee", "Forex Fee", "Cross Border Fee", "3DS Fee", "Scheme Fee",
      "Interchange fee", "Reserve Deduction", "Total Deductions", "Net in Settlement Currency", "Category",	"Payout ID", "Payout Date", "Dunning",	"Parent Transaction"]
    ;
  }

  public override getPayoutHeaders(): Array<string> {
    // 13 columns => IC++ payout includes the extra "End of Month Deductions" column
    if (this.payoutDetails[0]?.length === 13) {
      return ["ID", "Created Date", "Status", "Type", "Date of Transactions", "Transactions", "Currency", "Gross",
        "Deductions", "End of Month Deductions", "Net", "Category", "Comments"];
    }
    // Backward compatibility: older IC++ reports include "End of Month Deductions" at 10 columns
    // (before "Status", "Type" and "Date of Transactions" were added).
    if (this.payoutDetails[0]?.length === 10) {
      return ["ID", "Created Date", "Transactions", "Currency", "Gross", "Deductions",
        "End of Month Deductions", "Net", "Category", "Comments"];
    }
    return super.getPayoutHeaders();
  }
}